import { render } from "./CreateURL.vue?vue&type=template&id=9ace270a&scoped=true"
import script from "./CreateURL.vue?vue&type=script&lang=js"
export * from "./CreateURL.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=9ace270a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ace270a"]])

export default __exports__